import script from "./ProfileCommunication.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCommunication.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import RecordCard from "@/components/customers/record/RecordCard.vue";
import RecordSettingRow from "@/components/customers/record/RecordSettingRow.vue";
script.components = Object.assign({}, { RecordCard, RecordSettingRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { RecordCard, RecordSettingRow }, script.__o.components);}